<template>
  <Workpackage
  :workpackage="workpackage"
  :workpackage_count="waggon.tworkpackages.length"
  :waggon_duration="waggon.length"
  />
</template>
<script>
import { mapGetters } from 'vuex';
import Workpackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';

  export default {
    props: ['waggon', 'workpackage'],
    components: {
      Workpackage,
    },
    data: () => ({
    }),
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
    }
  }
</script>
<style>
  .class {

  }
</style>
